import { KeyFact, ProcessStep, Strength } from './types';

export const HERO = {
  headline: 'Empowering Digital Transformation',
  subhead: 'Innovative IT solutions in ServiceNow, AI, and custom development to drive your business forward.',
};

/**
 * CLAIMS REQUIRING VERIFICATION (see REMEDIATION_NOTES.md): all four of
 * these figures are unsourced -- no date, no methodology, no backing data
 * found anywhere in the repo. Carried over verbatim, not rewritten or
 * embellished, per Task 6.
 */
/**
 * REMOVED from this list: "8+ Certified Professionals". A ServiceNow
 * certification is awarded to a person, and no roster of who holds what
 * exists in this repo, so the site cannot stand behind a headcount of
 * certified staff. The five real credentials are named individually in
 * content/certifications.ts and rendered next to the services they back,
 * which is a claim a buyer can check. Do not reinstate a count here.
 */
export const KEY_FACTS: KeyFact[] = [
  { id: 1, number: '40+', label: 'Years of Tech Leadership' },
  { id: 3, number: '200+', label: 'Successful Projects' },
  { id: 4, number: 'Global', label: 'Presence & Partnerships' },
];

export const STRENGTHS: Strength[] = [
  {
    id: 1,
    iconKey: 'robot',
    title: 'AI & Automation',
    description: 'Cutting-edge artificial intelligence solutions tailored to your needs.',
  },
  {
    id: 2,
    iconKey: 'cloud',
    title: 'ServiceNow Excellence',
    description: 'Certified experts delivering transformative ServiceNow implementations.',
  },
  {
    id: 3,
    iconKey: 'code',
    title: 'Custom Development',
    description: 'Bespoke software solutions that solve your unique challenges.',
  },
];

/**
 * The five steps and their heading are rendered by
 * components/EngagementProcess on both the homepage and /services. They live
 * here, next to each other, so there is one description of how an engagement
 * runs and the two pages cannot drift apart.
 */
export const ENGAGEMENT_PROCESS = {
  heading: 'How Engagements Work',
};

export const PROCESS_STEPS: ProcessStep[] = [
  {
    id: 1,
    number: '01',
    title: 'Understand',
    description:
      'We begin with the business process, users, constraints, and desired outcomes rather than a predetermined technical answer.',
    iconKey: 'search',
  },
  {
    id: 2,
    number: '02',
    title: 'Design',
    description:
      'We translate those needs into a practical roadmap, architecture, data model, integration strategy, and delivery plan.',
    iconKey: 'pencil',
  },
  {
    id: 3,
    number: '03',
    title: 'Build',
    description:
      'We configure, develop, integrate, and demonstrate working increments so stakeholders can validate progress early.',
    iconKey: 'code',
  },
  {
    id: 4,
    number: '04',
    title: 'Enable',
    description:
      'We test the solution, prepare users, document what was built, and transfer the knowledge needed for long-term ownership.',
    iconKey: 'graduation',
  },
  {
    id: 5,
    number: '05',
    title: 'Improve',
    description:
      'After launch, we help monitor performance, address new priorities, and keep the platform aligned with changing business needs.',
    iconKey: 'chart',
  },
];
